import React from 'react';
import MainLayout from '../../layout/layout';
import playmanagerLogo from '../../../assets/PlayManager.png';

const TorneosLanding = () => {
  const isMobile = window.innerWidth <= 768;

  return (
    <MainLayout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 120px)',
          padding: isMobile ? 24 : 48,
          backgroundColor: 'transparent',
        }}
      >
        <img
          src={playmanagerLogo}
          alt="PlayManager"
          style={{
            maxWidth: isMobile ? 200 : 280,
            height: 'auto',
          }}
        />
      </div>
    </MainLayout>
  );
};

export default TorneosLanding;
